import Undo from 'undo.js';

import { uniqueId } from 'cadenza/utils/unique-id';
import { SketchFeatureProperty } from 'cadenza/map/classic-sketch-layer/sketch-feature-property';
import { getMainStyle } from 'cadenza/map/classic-sketch-layer/sketch-style';

export class GroupCommand extends Undo.Command {

  constructor (layer, features) {
    super();
    this.layer = layer;
    this.features = features.slice();
    this.featureIdToZIndex = {};
  }

  execute () {
    const group = uniqueId();
    groupFeatures(group, this.layer, this.features, this.featureIdToZIndex);
  }

  undo () {
    ungroupFeatures(this.layer, this.features, this.featureIdToZIndex);
  }

}

export class UngroupCommand extends Undo.Command {

  constructor (layer, groups) {
    super();
    this.layer = layer;
    this.groups = { ...groups };
  }

  execute () {
    // ungrouping does not change the zIndexes so we pass an empty map
    ungroupFeatures(this.layer, Object.values(this.groups).flatMap(features => features), {});
  }

  undo () {
    for (const [ group, features ] of Object.entries(this.groups)) {
      groupFeatures(group, this.layer, features, {});
    }
  }

}

function groupFeatures (group, layer, features, featureIdToZIndex) {
  let maxZIndex = 0;
  for (const feature of features) {
    feature.set(SketchFeatureProperty.GROUP, group);
    const zIndex = getMainStyle(feature).getZIndex();
    featureIdToZIndex[feature.getId()] = zIndex;
    if (zIndex > maxZIndex) {
      maxZIndex = zIndex;
    }
  }
  for (const feature of features) {
    getMainStyle(feature).setZIndex(maxZIndex);
  }
  layer.sortFeaturesByZIndex();
  if (features.length) {
    // only draw group selection box around first feature in group
    features[0].set(SketchFeatureProperty.GROUP_FEATURES, features);
  }
}

function ungroupFeatures (layer, features, featureIdToZIndex) {
  for (const feature of features) {
    feature.unset(SketchFeatureProperty.GROUP);
    const zIndex = featureIdToZIndex[feature.getId()];
    if (zIndex) {
      getMainStyle(feature).setZIndex(zIndex);
    }
    if (feature.get(SketchFeatureProperty.GROUP_FEATURES)) {
      feature.unset(SketchFeatureProperty.GROUP_FEATURES);
    }
  }
  layer.sortFeaturesByZIndex();
}
